<template>
  <div class="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
[v-cloak] {
  display: none;
}

* {
  box-sizing: border-box;
}
body{
  color: #333;
}

.app {
  min-height: 100vh;
  max-height: 100%;
}

.mian {
  padding-top: 50px;
  font-size: 14px;
}
.view{
  padding-top: 50px;
  font-size: 14px;
  min-height: 100vh;
  max-height: 100%;
}

.ash {
  min-height: 100vh;
  max-height: 100%;
  background: #F3F4F6;
}


body::-webkit-scrollbar,
html::-webkit-scrollbar,
.app::-webkit-scrollbar,
.view::-webkit-scrollbar,
.mian::-webkit-scrollbar {
  display: none;
}

.imagecss {
  width: 100%;
  height: 100%;
  vertical-align: top;
  object-fit: contain;
}
</style>
